import api from '../../config/api_config';

export const productsApi = {
    getProducts: (params) => api.get('/products/', { params }),
    getProductById: (id) => api.get(`/products/${id}/`),
    createProduct: (data) => api.post('/products/', data),
    updateProduct: (id, data) => api.put(`/products/${id}/`, data),
    deleteProduct: (id) => api.delete(`/products/${id}/`),
    
    // Categories
    getCategories: () => api.get('/product-categories/'),
    
    // Reviews
    getProductReviews: (productId) => api.get(`/products/${productId}/reviews/`),
    addReview: (productId, data) => api.post(`/products/${productId}/reviews/`, data)
};